import { format } from 'date-fns';
import type { CalendarEventType } from '@/components/event-calendar/types';

export interface CalendlyEventDTO {
	id: string;
	title: string;
	start: string;
	end: string;
	location?: string;
	locationDetails?: string;
	joinUrl?: string;
	notes?: string;
	hosts?: string[];
	guests?: string[];
	inviteeCount?: number;
}

export interface CalendlyInvitee {
	name?: string;
	email?: string;
	answers?: { question: string; answer: string }[];
}

export interface CalendlyEventDetails {
	status: 'ready' | 'disconnected' | 'reconnect';
	description?: string;
	invitees: CalendlyInvitee[];
}

export const toCalendlyCalendarEvent = (
	item: CalendlyEventDTO,
	accountName?: string | null
): CalendarEventType => {
	const startDate = new Date(item.start);
	let endDate = new Date(item.end);
	// A meeting that ends on the stroke of midnight belongs to the day before
	if (format(endDate, 'HH:mm') === '00:00' && endDate > startDate) {
		endDate = new Date(endDate.getTime() - 60 * 1000);
	}

	return {
		id: `calendly:${item.id}`,
		title: item.title,
		description: '',
		startDate,
		endDate,
		startTime: format(startDate, 'HH:mm'),
		endTime: format(endDate, 'HH:mm'),
		color: 'calendly',
		isRepeating: false,
		isRepeatingInterval: 'daily' as const,
		isRepeatingExcludedDates: [],
		calendly: {
			id: item.id,
			start: item.start,
			end: item.end,
			...(accountName ? { accountName } : {}),
			...(item.location ? { location: item.location } : {}),
			...(item.locationDetails
				? { locationDetails: item.locationDetails }
				: {}),
			...(item.joinUrl ? { joinUrl: item.joinUrl } : {}),
			...(item.notes ? { notes: item.notes } : {}),
			...(item.hosts?.length ? { hosts: item.hosts } : {}),
			...(item.guests?.length ? { guests: item.guests } : {}),
			...(item.inviteeCount !== undefined
				? { inviteeCount: item.inviteeCount }
				: {}),
		},
	};
};
